import { getFeatureLabel } from '@/lib/ai/context/providers/get-feature-label'
import { getFeaturePresentationData } from '@/lib/ai/context/providers/get-feature-presentation-data'
import { getSelectedMapFeature } from '@/lib/ai/context/providers/get-selected-map-feature'
import { featureSelected } from '@/services/map-service'

/**
 * Selected map feature, when one exists. Emits a readable, pipe-delimited line
 * — `selected map feature: label: … | source: … | layer: … | geometry: … | <key>: <value> …`.
 */
export const getSelectedFeatureContext = (): string => {
  const selected = featureSelected()
  if (!selected) {
    return ''
  }
  const selectedId = selected.id
  if (selectedId === undefined || selectedId === null) {
    return ''
  }
  const match = getSelectedMapFeature()
  const label = match ? getFeatureLabel(match) : ''
  const layer = match?.layer ?? selected.sourceLayer ?? ''

  const parts: string[] = []
  if (label) {
    parts.push(`label: ${label}`)
  }
  if (selected.source) {
    parts.push(`source: ${selected.source}`)
  }
  if (layer) {
    parts.push(`layer: ${layer}`)
  }
  if (match?.geometry?.type) {
    parts.push(`geometry: ${match.geometry.type}`)
  }
  if (match) {
    const data = getFeaturePresentationData(match)
    if (data) {
      for (const row of data) {
        const [key, value] = Object.entries(row)[0] ?? []
        if (key && value) {
          parts.push(`${key}: ${value}`)
        }
      }
    }
  }
  if (parts.length === 0) {
    return ''
  }
  return `selected map feature: ${parts.join(' | ')}\n`
}
